// extracted by mini-css-extract-plugin
export default {"hintContainer":"HintBox_hintContainer__y5otc","helpIcon":"HintBox_helpIcon__8KVF5","heartbeat":"HintBox_heartbeat__lCJVQ"};